import React, { useState } from "react";
import "./Header.css";
import { FaBars, FaTimes } from "react-icons/fa"; // Import icons for hamburger menu
import { Link } from "react-router-dom";
import logo from "../../Assets/logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to close the menu when a link is clicked
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="Header">
      
      <div className="Header-hero">
     
      <Link to="/"><img className="Header-logo" src={logo} alt="School Logo" /></Link>
        <h1 className="Header-title">
          V.D. PRASADA RAO
          <br />
          MEMORIAL HIGH SCHOOL
        </h1>
        
      </div>
      
      <div className="Header-control">
        {/* Hamburger Menu for Small Screens */}
        <div className="hamburger-menu" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`Header-navbar ${isMenuOpen ? "open" : ""}`}>
          <Link to="/" className="Header-navbar-home" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/about" className="Header-navbar-about" onClick={closeMenu}>
            About
          </Link>
          <Link
            to="/curriculum"
            className="Header-navbar-curriculum"
            onClick={closeMenu}
          >
            Curriculum
          </Link>
          <Link
            to="/gallery"
            className="Header-navbar-gallery"
            onClick={closeMenu}
          >
            Gallery
          </Link>
          <Link
            to="/careers"
            className="Header-navbar-gallery"
            onClick={closeMenu}
          >
            Careers
          </Link>
        </div>
      </div>
      <Link to="/enquiry" className="enquiry-button">
        Enquiry
      </Link>
    </div>
  );
};

export default Header;
